import React from 'react';
import { motion } from 'framer-motion';
interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  children: ReactNode;
  variant?: 'primary' | 'secondary' | 'outline';
  fullWidth?: boolean;
}
export function Button({
  children,
  variant = 'primary',
  fullWidth = false,
  className = '',
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center px-8 py-4 text-lg font-bold rounded-full transition-all duration-300 shadow-lg hover:shadow-xl transform hover:-translate-y-1 focus:outline-none focus:ring-2 focus:ring-offset-2';
  const variants = {
    primary: 'bg-[#C9A84C] text-[#2D2D2D] hover:bg-[#D4B55D] focus:ring-[#C9A84C]',
    secondary: 'bg-[#0D5C63] text-white hover:bg-[#0A4A50] focus:ring-[#0D5C63]',
    outline: 'bg-transparent border-2 border-[#0D5C63] text-[#0D5C63] hover:bg-[#0D5C63] hover:text-white'
  };
  const widthClass = fullWidth ? 'w-full' : '';
  return <motion.button whileTap={{
    scale: 0.98
  }} className={`${baseStyles} ${variants[variant]} ${widthClass} ${className}`} {...props} data-id="element-163">
      {children}
    </motion.button>;
}